import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JuridicoRoutingModule } from './juridico-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JuridicoRoutingModule
  ]
})
export class JuridicoModule { }
